import * as React from 'react';
import { Dialog } from '@fluentui/react/lib/Dialog';
import RbLabel, { LabelSize } from '../../bosch-react/components/label/RbLabel';
import RbLoadingSpinner from '../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import { RootState } from '../../store/store';
import { connect } from 'react-redux';

interface IProps {
    dialogMessage: string,
}
class LoadingDialog extends React.Component<IProps, any> {

    render() {
        let dialogMessage: string | boolean = this.props.dialogMessage;
        if (!!this.props.dialogMessage===false) {
            return null;
        }
        else {
            return (
                <Dialog minWidth="30vw" maxWidth="30vw"
                    modalProps={{
                        isBlocking: true,
                        containerClassName: 'ms-dialogMainOverride',
                        styles:{root:{
                            zIndex:"999"
                        }},
                        isDarkOverlay:false
                    }}
                    dialogContentProps={{
                        showCloseButton: false
                    }}
                    hidden={false}
                    onDismiss={() => { }}
                >
                    <div className="ms-Grid">
                        <div className="ms-Grid-row" style={{ textAlign: "center" }}>
                            <div style={{ display: "block", width: "100%", height: "5rem", textAlign: "center" }}>
                                <RbLoadingSpinner />
                            </div>
                            <RbLabel size={LabelSize.Large} isInline={false}>{dialogMessage}</RbLabel>
                        </div>
                    </div>
                </Dialog>
            );
        }
    }

}
interface ILoadingBasicDialogProps{
    dialogMessage?:string
}
export class LoadingBasicDialog extends React.Component<ILoadingBasicDialogProps, any> {

    render() {
        if (!!this.props.dialogMessage) {
            return (
                <Dialog minWidth="30vw" maxWidth="30vw"
                    modalProps={{
                        isBlocking: true,
                        containerClassName: 'ms-dialogMainOverride',
                        styles:{root:{
                            zIndex:"999"
                        }},
                        isDarkOverlay:false
                    }}
                    dialogContentProps={{
                        showCloseButton: false
                    }}
                    hidden={false}
                    onDismiss={() => { }}
                >
                    <div className="ms-Grid">
                        <div className="ms-Grid-row" style={{ textAlign: "center" }}>
                            <div style={{ display: "block", width: "100%", height: "5rem", textAlign: "center" }}>
                                <RbLoadingSpinner />
                            </div>
                            <RbLabel size={LabelSize.Large} isInline={false}>{this.props.dialogMessage}</RbLabel>
                        </div>
                    </div>
                </Dialog>
            );
        }
        else {
            return <></>
        }
    }

}
const mapStateToProps = (state: RootState) => ({
    dialogMessage: state.util.dialogMessage,
  });
export default  connect(mapStateToProps)(LoadingDialog);